module.exports = __webpack_public_path__ + "static/img/3.58140b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/3.png
// module id = QUX8
// module chunks = 0